<template>
  <div class="dash-left-side dash-list-side" ref="studioList">
    <div class="plot-header-row">
      <span class="plot-title">Plots</span>
      <v-img :src="dash_create" alt="create" @click="createPlot" class="set-cursor create-btn-compact"></v-img>
    </div>
    <v-divider></v-divider>
    <div class="tab-div dash-access-toggle justify-space-between tabs-row">
      <v-btn-toggle
        v-model="isShared"
        class="axis-toggle"
        mandatory
        @update:modelValue="handleAccessToggleChange"
      >
        <v-btn :value="false" class="switch-btn" outlined>My Plots</v-btn>
        <v-btn :value="true" class="switch-btn" outlined>Shared</v-btn>
      </v-btn-toggle>
    </div>
    <div class="search-row">
      <v-text-field
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        placeholder="Search Plot"
        dense
        hide-details
        class="search-bar"
      />
    </div>
    <DashChartListingLoader v-if="showLoader == true" />
    <div class="dash-list-public" v-else>
      <div v-if="filteredCharts.length === 0">
        <h6>No Plots Found</h6>
      </div>
      <div
        v-for="(chart, index) in filteredCharts"
        :key="index"
        class="dash-list-items"
        :class="{ active: selectedChartId === chart.ID }"
        @click="selectChart(chart)"
        style="position: relative;"
      >
        <span class="dash-name" :title="chart.Name">{{ chart.Name }}</span>
        <div class="chart-actions">
          <img :src="GlobeSimple" alt="globe" title="Shared" v-if="isPublicChartByUser(chart)" class="globe-icon" />
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import api from "../../../axiosInterceptor";
import DashChartListingLoader from "../Loaders/DashChartListingLoader.vue";
import { mapGetters } from "vuex";
import {
  buildAxisDisplayNamesFromChart,
  buildSelectColumnsFromState,
  parseYAxisKeysFromChart,
  resolveColumnDisplayName,
  resolveYAxisDisplayNames,
} from "../../../utils/chartAxisUtils";

export default {
  name: "StudioList",
  components: { DashChartListingLoader },
  data() {
    return {
      GlobeSimple: require("../../../assets/Svg/GlobeSimple.svg"),
      chartsArr: [],
      isShared: false,
      showLoader: true,
      selectedChartId: null,
      searchQuery: "",
      selectedXAxisKey: [],
      selectedYAxisKey: [],
      selectedZAxisKey: [],
      selectedColorGroupKey: null,
      dataFetchAbortController: null,
      tableTypeAbortController: null,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    filteredCharts() {
      const userEmail = this.$store.getters["tenantId/getUser"]?.username;
      let filtered = this.chartsArr.filter((chart) =>
        this.isShared
          ? chart.AccessLevel === "public"
          : chart.AccessLevel === "private" ||
            (chart.AccessLevel === "public" && chart.CreatedBy === userEmail)
      );
      
      const publicChartsByUser = this.chartsArr.filter(chart => chart.AccessLevel === 'public' && chart.CreatedBy === userEmail);
      const allPublicCharts = this.chartsArr.filter(chart => chart.AccessLevel === 'public');
    
      
    
      
      if (this.searchQuery) {
        filtered = filtered.filter((chart) =>
          chart.Name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
      return filtered;
    },
    dash_create() {
      return this.isDarkMode ? require("../../../assets/Svg/Dashboard/create-btn-stu-dark.svg") : require("../../../assets/Svg/Dashboard/create-btn-stu.svg");
    },
  },
  watch: {
    isDarkMode(newVal) {
      this.dash_create = newVal ? require("../../../assets/Svg/Dashboard/create-btn-stu-dark.svg") : require("../../../assets/Svg/Dashboard/create-btn-stu.svg");
    },
    /** When the visible list changes (e.g. My/Shared toggle, search), keep a selection or default to first plot */
    filteredCharts(newList) {
      if (this.showLoader) return;
      if (!newList || newList.length === 0) return;
      if (this.selectedChartId != null && newList.some((c) => c.ID === this.selectedChartId)) {
        return;
      }
      this.$nextTick(() => this.maybeSelectFirstAvailablePlot());
    },
  },
  beforeDestroy() {
    // Cancel all pending requests when component is destroyed
    this.cancelAllRequests();
  },
  beforeUnmount() {
    this.cancelAllRequests();
  },
  methods: {
    cancelDataFetchRequest() {
      if (this.dataFetchAbortController) {
        this.dataFetchAbortController.abort();
        this.dataFetchAbortController = null;
      }
    },
    
    cancelTableTypeRequest() {
      if (this.tableTypeAbortController) {
        this.tableTypeAbortController.abort();
        this.tableTypeAbortController = null;
      }
    },
    
    
    cancelAllRequests() {
      this.cancelDataFetchRequest();
      this.cancelTableTypeRequest();
    },

    handleAccessToggleChange() {
      void 0;
    },
    getSavedChartForDisplayNames() {
      try {
        const raw =
          localStorage.getItem("savedChartData") ||
          localStorage.getItem("newsavedChartData");
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    async selectChart(chart) {
      
      
      this.selectedChartId = chart.ID;
      localStorage.setItem('savedChartData', JSON.stringify(chart));
      
      
      await this.tableTypeChange(chart.TableType);
      
      this.checkAndApplyPendingFilter(chart);
      
      this.getTableData(chart);
      this.$emit("selected-plot", chart);
    },
    async getTableData(chart) {
      this.selectedXAxisKey = chart.XAxisColumn;
      this.selectedYAxisKey = parseYAxisKeysFromChart(chart);
      this.selectedZAxisKey = chart.ZAxisColumn;
      this.selectedColorGroupKey = chart.GroupColumn;
      
      this.cancelDataFetchRequest();
      
      this.dataFetchAbortController = new AbortController();
      
      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      this.$emit("sample-error", "");
      
      var selectedType = localStorage.getItem("selectedTableType");
      
      let selectedColumns = buildSelectColumnsFromState({
        xAxisKey: chart.XAxisColumn,
        yAxisKeys: parseYAxisKeysFromChart(chart),
        zAxisKey: chart.ZAxisColumn,
        groupColumn: chart.GroupColumn,
      });
      if (selectedColumns.length === 0) {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        return;
      }
      
      try {
        const queryParams = {
          selectColumns: JSON.stringify(selectedColumns)
        };
        
        if (chart.Filter) {
          const chartFilter = chart.Filter;
          
          if (chartFilter.asset && chartFilter.asset.length) {
            queryParams.asset = JSON.stringify(chartFilter.asset);
          }
          if (chartFilter.field && chartFilter.field.length) {
            queryParams.field = JSON.stringify(chartFilter.field);
          }
          if (chartFilter.well && chartFilter.well.length) {
            queryParams.well = JSON.stringify(chartFilter.well);
          }
          if (chartFilter.reservoir && chartFilter.reservoir.length) {
            queryParams.reservoir = JSON.stringify(chartFilter.reservoir);
          }
          if (chartFilter.fluidType && chartFilter.fluidType.length) {
            queryParams.fluidType = JSON.stringify(chartFilter.fluidType);
          }
          if (chartFilter.sampleType && chartFilter.sampleType.length) {
            queryParams.sampleType = JSON.stringify(chartFilter.sampleType);
          }
          if (chartFilter.fluidClassification && chartFilter.fluidClassification.length) {
            queryParams.fluidClassification = JSON.stringify(chartFilter.fluidClassification);
          }
          if (chartFilter.fluidSampleID && chartFilter.fluidSampleID.length) {
            queryParams.fluidSampleID = JSON.stringify(chartFilter.fluidSampleID);
          }
          if (chartFilter.fluidSampleContainerID && chartFilter.fluidSampleContainerID.length) {
            queryParams.fluidSampleContainerID = JSON.stringify(chartFilter.fluidSampleContainerID);
          }
          if (chartFilter.source) {
            queryParams.source = `"${chartFilter.source}"`;
          }
          if (chartFilter.depth) {
            queryParams.depth = JSON.stringify(chartFilter.depth);
          }
          if (chartFilter.formationPressure) {
            queryParams.formationPressure = JSON.stringify(chartFilter.formationPressure);
          }
          if (chartFilter.formationTemperature) {
            queryParams.formationTemperature = JSON.stringify(chartFilter.formationTemperature);
          }
        }
        
        const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join("&");
        
        
        const response = await api.get(
          `public/api/tables/data/${selectedType}?${queryString}`,
          { signal: this.dataFetchAbortController.signal }
        );
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          if (response.data.error) {
            this.$emit("sample-error", response.data.error);
            return;
          }
          
          this.tableData = response.data.data.samples.rows;
          
          if (this.tableData === null) {
            this.$emit("sample-error", "Data is not available to plot chart.");
            return;
          }
          
          await this.extractAllAxisData();
        } else if (response && response.data && response.data.message) {
          this.$emit("sample-error", response.data.message);
        } else if (response && response.data && response.data.error) {
          this.$emit("sample-error", response.data.error);
        } else {
          this.$emit("sample-error", "Error fetching table data.");
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }
        
        this.$emit("sample-error", "An error occurred while fetching data.");
      } finally {
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        this.dataFetchAbortController = null;
      }
    },
    async extractAllAxisData() {
      const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
        ? this.selectedYAxisKey 
        : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];

      if (!this.tableData || this.tableData.length === 0) {
        return;
      }

      this.showLoaders = true;
      this.$emit("loading-state", this.showLoaders);
      
      this.xAxisData = [];
      this.yAxisData = [];
      this.zAxisData = [];
      this.colorGroupData = [];
      
      this.autoFixColumnNames();
      
      const isLargeDataset = this.tableData.length > this.dataChunkSize;
      try {
        const savedChart = this.getSavedChartForDisplayNames();
        const catalog = {
          xAxisItems: this.xAxisItems,
          yAxisItems: this.yAxisItems,
          zAxisItems: this.zAxisItems,
          colorGroupItems: this.colorGroupItems,
        };
        const axisLabels = buildAxisDisplayNamesFromChart(savedChart, catalog);

        if (this.selectedXAxisKey) {
          if (isLargeDataset) {
            this.xAxisData = await this.findXAxisDataChunked();
          } else {
            this.xAxisData = this.findXAxisData();
          }
          
          var allCaptions = this.tableData?.map((row) => row.caption || "");
          const xDisplayName = resolveColumnDisplayName(
            this.selectedXAxisKey,
            this.xAxisItems,
            axisLabels.xAxisDisplayName
          );
          this.$emit("x-axis-selected", { 
            data: this.xAxisData, 
            displayName: xDisplayName, 
            caption: allCaptions 
          });
        }

        if (yAxisKeys.length > 0) {
          this.yAxisData = this.findYAxisData();
          const allCaptions = this.tableData?.map((row) => row.caption || "");
          const yAxisDisplayNames = resolveYAxisDisplayNames(
            yAxisKeys,
            this.yAxisItems,
            axisLabels.yAxisDisplayNames
          );
          
          this.$emit("y-axis-selected", { 
            data: this.yAxisData, 
            displayNames: yAxisDisplayNames, 
            caption: allCaptions 
          });
        }

        if (this.selectedZAxisKey) {
          if (isLargeDataset) {
            this.zAxisData = await this.findZAxisDataChunked();
          } else {
            this.zAxisData = this.findZAxisData();
          }
          
          const zDisplayName = resolveColumnDisplayName(
            this.selectedZAxisKey,
            this.zAxisItems,
            axisLabels.zAxisDisplayName
          );
          
          this.$emit("z-axis-selected", { 
            data: this.zAxisData, 
            displayName: zDisplayName
          });
        }
        
        this.handleGroupSelection();

        await new Promise(resolve => setTimeout(resolve, 100));
      
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        
        if (this.selectedColorGroupKey && this.selectedColorGroupKey.trim() !== '') {
          this.processColorGroupData();
        } else {
          this.$emit("grouped-y-axis-data", {});
          this.$emit("grouped-x-axis-data", {});
          this.$emit("grouped-z-axis-data", {});
          this.$emit("color-group-key", "");
          this.$emit("color-group-display-name", "");
        }
        
        this.$nextTick(() => {
          this.$emit("chart-updated");
          if (this.tableData && this.tableData.length > 0) {
            this.$emit("table-data", this.tableData);
          }
        });

      } catch (error) {
        console.error('❌ Error during data extraction:', error);
        this.showLoaders = false;
        this.$emit("loading-state", this.showLoaders);
        this.$emit("sample-error", "Error processing chart data");
      }
    },
    processColorGroupData() {
      if (!this.selectedColorGroupKey || !this.tableData || this.tableData.length === 0) {
        return;
      }
      
      const colorGroupValues = [...new Set(this.tableData.map(row => row[this.selectedColorGroupKey]).filter(value => value !== null && value !== undefined))];
      
      if (colorGroupValues.length === 0) {
        return;
      }
      
      const groupedYAxisData = {};
      const groupedXAxisData = {};
      const groupedZAxisData = {};
      
      colorGroupValues.forEach(value => {
        groupedYAxisData[value] = [];
        groupedXAxisData[value] = [];
        groupedZAxisData[value] = [];
      });
      
      this.tableData.forEach(row => {
        const colorGroupValue = row[this.selectedColorGroupKey];
        if (colorGroupValues.includes(colorGroupValue)) {
          const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
            ? this.selectedYAxisKey 
            : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
            
          if (yAxisKeys.length > 0) {
            const yAxisRowData = yAxisKeys.map(key => {
              const decimalKey = `${key}_decimal`;
              if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
                const value = parseFloat(row[key]);
                if (!isNaN(value)) {
                  const maxDecimals = Math.min(row[decimalKey], 6);
                  return value.toFixed(maxDecimals);
                }
              }
              return row[key];
            });
            groupedYAxisData[colorGroupValue].push(yAxisRowData);
          }
          
          if (this.selectedXAxisKey) {
            const xAxisRowData = row[this.selectedXAxisKey];
            groupedXAxisData[colorGroupValue].push(xAxisRowData);
          }
          
          if (this.selectedZAxisKey) {
            const zAxisRowData = row[this.selectedZAxisKey];
            groupedZAxisData[colorGroupValue].push(zAxisRowData);
          }
        }
      });
      
      this.$emit("grouped-y-axis-data", groupedYAxisData);
      this.$emit("grouped-x-axis-data", groupedXAxisData);
      this.$emit("grouped-z-axis-data", groupedZAxisData);
      this.$emit("color-group-key", this.selectedColorGroupKey);
      
      const selectedColorGroupItem = this.colorGroupItems?.find(item => item.name === this.selectedColorGroupKey);
      const colorGroupDisplayName = selectedColorGroupItem ? selectedColorGroupItem.displayName : this.selectedColorGroupKey;
      this.$emit("color-group-display-name", colorGroupDisplayName);
    },
    findYAxisData() {
      const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
        ? this.selectedYAxisKey 
        : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];

      if (!this.tableData || !this.tableData.length) {
        return [];
      }

      if (!yAxisKeys.length) {
        return [];
      }

      const firstRow = this.tableData[0];

      var columnData = yAxisKeys.map((col) => {
        let actualColumnName = col;
        if (!(col in firstRow)) {
          const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
            key.toLowerCase() === col.toLowerCase()
          );
          if (caseInsensitiveMatch) {
            actualColumnName = caseInsensitiveMatch;
          } else {
            const partialMatch = Object.keys(firstRow).find(key => 
              key.includes(col) || col.includes(key)
            );
            if (partialMatch) {
              actualColumnName = partialMatch;
            } else {
              const similarKeys = Object.keys(firstRow).filter(key => 
                key.toLowerCase().includes(col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) ||
                col.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(key.toLowerCase())
              );
              if (similarKeys.length > 0) {
                actualColumnName = similarKeys[0];
              }
            }
          }
        }
        
        const decimalKey = `${actualColumnName}_decimal`;
        
        const rawData = this.tableData.map((row) => {
          const value = row[actualColumnName];
          const decimalValue = row[decimalKey];
          if (decimalValue !== undefined && decimalValue !== null) {
            const numValue = parseFloat(value);
            if (!isNaN(numValue)) {
              const maxDecimals = Math.min(decimalValue, 6);
              const numericValue = parseFloat(numValue.toFixed(maxDecimals));
              return numericValue;
            }
          }
          return value;
        });
        return rawData;
      });
      return columnData;
    },
    findXAxisData() {
      if (!this.tableData || !this.tableData.length) {
        return [];
      }
      if (!this.selectedXAxisKey) {
        return [];
      }
      const firstRow = this.tableData[0];
      let actualColumnName = this.selectedXAxisKey;
      if (!(this.selectedXAxisKey in firstRow)) {
        const caseInsensitiveMatch = Object.keys(firstRow).find(key => 
          key.toLowerCase() === this.selectedXAxisKey.toLowerCase()
        );
        if (caseInsensitiveMatch) {
          actualColumnName = caseInsensitiveMatch;
        } else {
          const partialMatch = Object.keys(firstRow).find(key => 
            key.includes(this.selectedXAxisKey) || this.selectedXAxisKey.includes(key)
          );
          if (partialMatch) {
            actualColumnName = partialMatch;
          }
        }
      }
      const decimalKey = `${actualColumnName}_decimal`;
      const rawData = this.tableData.map((row) => {
        const value = row[actualColumnName];
        const decimalValue = row[decimalKey];
        if (decimalValue !== undefined && decimalValue !== null) {
          const numValue = parseFloat(value);
          if (!isNaN(numValue)) {
            const maxDecimals = Math.min(decimalValue, 6);
            const formattedValue = numValue.toFixed(maxDecimals);
            return formattedValue;
          }
        }
        return value;
      });
      return rawData;
    },
    findZAxisData() {
      if (this.tableData && this.selectedZAxisKey) {
        const decimalKey = `${this.selectedZAxisKey}_decimal`;
        return this.tableData.map((row) => {
          if (row[decimalKey] !== undefined && row[decimalKey] !== null) {
            const value = parseFloat(row[this.selectedZAxisKey]);
            if (!isNaN(value)) {
              const maxDecimals = Math.min(row[decimalKey], 6);
              return parseFloat(value.toFixed(maxDecimals)); // Convert back to number
            }
          }
          return row[this.selectedZAxisKey];
        });
      }
      return [];
    },
    findcolorGroupData() {
      if (this.tableData && this.selectedColorGroupKey) {
        var columnData = this.tableData.map(row => row[this.selectedColorGroupKey]);
        const uniqueValues = [...new Set(columnData.filter(item => item !== undefined && item !== null))];
        return uniqueValues;
      }
      return [];
    },
    autoFixColumnNames() {
      if (!this.tableData || !this.tableData.length) {
        return;
      }
      const firstRow = this.tableData[0];
      const availableKeys = Object.keys(firstRow);
      if (this.selectedXAxisKey && !(this.selectedXAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedXAxisKey, availableKeys);
        if (fixedName) {
          this.selectedXAxisKey = fixedName;
        }
      }
      if (this.selectedYAxisKey) {
        let yAxisKeys = Array.isArray(this.selectedYAxisKey)
          ? this.selectedYAxisKey
          : [this.selectedYAxisKey];
        yAxisKeys = yAxisKeys
          .flatMap(key => typeof key === "string" ? key.split(",") : [key])
          .map(key => typeof key === "string" ? key.trim() : key)
          .filter(key => key !== undefined && key !== null && key !== "");
        if (this.selectedColorGroupKey) {
          yAxisKeys = yAxisKeys.filter(col => col !== this.selectedColorGroupKey);
        }
        if (yAxisKeys.length > 0) {
          const fixedYKeys = yAxisKeys.map(col => {
            if (col && !(col in firstRow)) {
              const fixedName = this.findBestColumnMatch(col, availableKeys);
              if (fixedName) {
                return fixedName;
              }
            }
            return col;
          });
          this.selectedYAxisKey = Array.isArray(this.selectedYAxisKey)
            ? fixedYKeys
            : fixedYKeys[0];
        } else {
          this.selectedYAxisKey = Array.isArray(this.selectedYAxisKey) ? [] : null;
        }
      }
      if (this.selectedZAxisKey && !(this.selectedZAxisKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedZAxisKey, availableKeys);
        if (fixedName) {
          this.selectedZAxisKey = fixedName;
        }
      }
      if (this.selectedColorGroupKey && !(this.selectedColorGroupKey in firstRow)) {
        const fixedName = this.findBestColumnMatch(this.selectedColorGroupKey, availableKeys);
        if (fixedName) {
          this.selectedColorGroupKey = fixedName;
        }
      }
    },
    findBestColumnMatch(selectedName, availableKeys) {
      const searchNames = Array.isArray(selectedName) 
        ? selectedName 
        : [selectedName];
      const safeToLower = (str) => String(str || '').toLowerCase();
      for (const name of searchNames) {
        const currentSearch = safeToLower(name);
        const exactMatch = availableKeys.find(key => 
          safeToLower(key) === currentSearch
        );
        if (exactMatch) return exactMatch;
        const partialMatch = availableKeys.find(key => {
          const lowerKey = safeToLower(key);
          return (
            lowerKey.includes(currentSearch) ||
            currentSearch.includes(lowerKey)
          );
        });
        if (partialMatch) return partialMatch;
        const cleanSelected = currentSearch.replace(/[^a-zA-Z0-9]/g, '');
        const cleanMatch = availableKeys.find(key => {
          const cleanKey = safeToLower(key).replace(/[^a-zA-Z0-9]/g, '');
          return (
            cleanKey.includes(cleanSelected) || 
            cleanSelected.includes(cleanKey)
          );
        });
        if (cleanMatch) return cleanMatch;
      }
      return null;
    },
    async handleGroupSelection() {
      if (this.selectedColorGroupKey && this.selectedColorGroupKey.length !=='') {
        if (this.colorGroupChanged) {
          if (this.colorGroupAbortController) {
            this.colorGroupAbortController.abort();
          }
          this.colorGroupAbortController = new AbortController();
          const signal = this.colorGroupAbortController.signal;
          let defaultFilterID = localStorage.getItem("defaultFilter");
          let filterActive = localStorage.getItem("filterActive")
          let selectedFilterId = localStorage.getItem("selectedFilterId")
          this.saveChartData();
          if (defaultFilterID || filterActive || selectedFilterId) {
            let filterData = this.savedFilterData
            let type = this.savedType
            this.onlyApiCall = true
            await this.getTableDataAgainstFilter({ filterData, type }, signal);
          }
          else {
            
            await this.getTableData(signal);
          }
          await this.extractAllAxisData();
        }
        this.colorGroupChanged = false
        this.colorGroupData = this.findcolorGroupData();
        if (this.selectedChartTypeName != "Histogram") {
          if (!this.yAxisData.length) {
            return;
          }
        }
        if (!this.xAxisData.length) {
          return;
        }
        const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
          ? this.selectedYAxisKey 
          : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
        if (yAxisKeys.length > 1) {
          this.selectedYAxisKey = yAxisKeys.slice(0, 1);
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.YAxisColumn = this.selectedYAxisKey.join(",")
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
          const yAxisDisplayNames = this.selectedYAxisKey.map(key => {
            const selectedColumn = this.yAxisItems.find(item => item.name === key);
            return selectedColumn ? selectedColumn.displayName : key;
          });
          this.$emit("y-axis-selected", { displayNames: yAxisDisplayNames });
        }
        
        
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.GroupColumn = this.selectedColorGroupKey
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
      }
      else {
        this.colorGroupData = [];
        this.$emit("grouped-y-axis-data", {});
        this.$emit("grouped-x-axis-data", {});
        this.$emit("grouped-z-axis-data", {});
        this.$emit("color-group-key", "");
        this.$emit("color-group-display-name", "");
        if (!this.yAxisData || this.yAxisData.length === 0) {
          if (this.tableData && this.tableData.length > 0) {
            this.yAxisData = this.findYAxisData();
            const yAxisKeys = Array.isArray(this.selectedYAxisKey) 
              ? this.selectedYAxisKey 
              : this.selectedYAxisKey ? [this.selectedYAxisKey] : [];
            const yAxisDisplayNames = yAxisKeys.map(key => {
              const selectedColumn = this.yAxisItems.find(item => item.name === key);
              return selectedColumn ? selectedColumn.displayName : key;
            });
            this.$emit("y-axis-selected", { data: this.yAxisData, displayNames: yAxisDisplayNames });
          }
        }
        let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
        if (savedChartData) {
          savedChartData.GroupColumn = ""
          localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
        }
      }
    },
    async tableTypeChange(selectedType) {
      this.cancelTableTypeRequest();
      
      this.tableTypeAbortController = new AbortController();
      
      this.loadingXAxisData = true;
      this.loadingYAxisData = true;
      this.loadingZAxisData = true;
      this.selectedTableTypeName = selectedType;
      const tableTypeString = JSON.stringify(selectedType);
      localStorage.setItem("selectedTableType", this.selectedTableTypeName);
      
      try {
        const response = await api.get(
          "public/api/tables/type?table=" +
          encodeURIComponent(tableTypeString),
          { signal: this.tableTypeAbortController.signal }
        );
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.loadingXAxisData = false;
          this.loadingYAxisData = false;
          this.loadingZAxisData = false;
          
          const columns = response.data.data.tableTypes.columns.filter(column => column.displayName);
          columns.sort((a, b) => (a.columnSortOrder || 999) - (b.columnSortOrder || 999));
          
          this.xAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredXAxisItems = this.xAxisItems;
          
          this.yAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredYAxisItems = this.yAxisItems;
          
          this.zAxisItems = columns.filter(column => column.canChart)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.sortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredZAxisItems = this.zAxisItems;
          
          
          this.colorGroupItems = columns.filter(column => column.legend)
            .map(column => ({ displayName: column.displayName, name: column.name, sortOrder: column.legendSortOrder || 999 }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
          this.filteredColorGroupItems = this.colorGroupItems;
          
          let savedChartData = JSON.parse(localStorage.getItem("savedChartData"));
          if (savedChartData) {
            savedChartData.TableType = this.selectedTableTypeName;
            localStorage.setItem("savedChartData", JSON.stringify(savedChartData));
          }
        } else if (response && response.data && response.data.message) {
          this.showSnackbar(response.data.message, "error");
        } else {
          this.showSnackbar("Error fetching table types.", "error");
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }
        
        this.loadingXAxisData = false;
        this.loadingYAxisData = false;
        this.loadingZAxisData = false;
      } finally {
        this.tableTypeAbortController = null;
      }
    },
    createPlot() {
      this.$emit("create-plot");
    },
    
    checkAndApplyPendingFilter(chart) {
      const pendingFilterData = localStorage.getItem("pendingFilterData");
      const filterActive = localStorage.getItem("filterActive");
      
      if (pendingFilterData && filterActive === "true") {
        try {
          const filterData = JSON.parse(pendingFilterData);
          
          if (!chart.Filter) {
            chart.Filter = {};
          }
          
          Object.assign(chart.Filter, filterData);
          
          localStorage.setItem('savedChartData', JSON.stringify(chart));
          
          localStorage.removeItem("pendingFilterData");
          
        } catch (error) {
          console.error("Error applying pending filter:", error);
          localStorage.removeItem("pendingFilterData");
        }
      }
    },
    
    checkForPendingFiltersOnMount() {
      const pendingFilterData = localStorage.getItem("pendingFilterData");
      const filterActive = localStorage.getItem("filterActive");
      const savedChartData = localStorage.getItem("savedChartData");
      
      if (pendingFilterData && filterActive === "true" && savedChartData) {
        try {
          const chart = JSON.parse(savedChartData);
          const filterData = JSON.parse(pendingFilterData);
          
          if (!chart.Filter) {
            chart.Filter = {};
          }
          
          Object.assign(chart.Filter, filterData);
          localStorage.setItem('savedChartData', JSON.stringify(chart));
          localStorage.removeItem("pendingFilterData");
          
        } catch (error) {
          console.error("Error applying pending filter on mount:", error);
          localStorage.removeItem("pendingFilterData");
        }
      }
    },
    
    
    isPublicChartByUser(chart) {
      const userEmail = this.$store.getters["tenantId/getUser"]?.username;
      const isPublic = chart.AccessLevel === 'public';
      const isCreatedByUser = chart.CreatedBy === userEmail;
      
      
      return isPublic && isCreatedByUser;
    },
    
    
    
    getSavedCharts() {
      this.showLoader = true;
      api
        .get("public/api/charts")
        .then((response) => {
          if (
            response &&
            response.data &&
            (response.data.statusCode === 200 ||
              response.data.statusCode === 201)
          ) {
            this.chartsArr = response.data.data.charts;
          }
        })
        .catch((error) => {
          void 0;
        })
        .finally(() => {
          this.showLoader = false;
          this.$nextTick(() => this.maybeSelectFirstAvailablePlot());
        });
    },

    /**
     * If nothing is selected (or selection is not in the current list), select the first
     * visible plot so Studio is not empty. Prefer localStorage savedChartData when it
     * matches a row in the current filtered list (session / deep-link alignment).
     */
    maybeSelectFirstAvailablePlot() {
      if (this.showLoader) return;
      const charts = this.filteredCharts;
      if (!charts || charts.length === 0) return;

      if (this.selectedChartId != null && charts.some((c) => c.ID === this.selectedChartId)) {
        return;
      }

      try {
        const raw = localStorage.getItem("savedChartData");
        if (raw) {
          const saved = JSON.parse(raw);
          if (saved && saved.ID) {
            const match = charts.find((c) => c.ID === saved.ID);
            if (match) {
              void this.selectChart(match);
              return;
            }
          }
        }
      } catch {
        /* ignore */
      }

      void this.selectChart(charts[0]);
    },

    // Method to select a chart by ID without reloading if already selected
    async selectChartById(chartId, forceRefresh = false) {
      if (this.selectedChartId === chartId && !forceRefresh) {
        return;
      }
      
      const chart = this.chartsArr.find(c => c.ID === chartId);
      
      if (chart) {
        if (!forceRefresh) {
          const currentSavedData = localStorage.getItem('savedChartData');
          if (currentSavedData) {
            try {
              const currentChart = JSON.parse(currentSavedData);
              if (currentChart.ID === chartId) {
                this.selectedChartId = chartId;
                this.$emit("selected-plot", chart);
                return;
              }
            } catch (e) {
              console.log('StudioList: Error parsing current saved data, proceeding with normal selection');
            }
          }
        }
        
        await this.selectChart(chart);
      } else {
        this.getSavedCharts();
        
        setTimeout(async () => {
          const retryChart = this.chartsArr.find(c => c.ID === chartId);
          if (retryChart) {
            await this.selectChart(retryChart);
          } else {
            console.log('StudioList: Chart still not found after refresh');
          }
        }, 1000);
      }
    },
  },
  mounted() {
    this.getSavedCharts();
    this.checkForPendingFiltersOnMount();
  },
};
</script>

<style scoped>
.dash-left-side {
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  background: #fff;
  border-right: 1px solid #e0e0e0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0,0,0,0.03);
  z-index: 2;
  padding: 16px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dash-left-side {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }
}

@media (max-width: 480px) {
  .dash-left-side {
    width: 260px;
    min-width: 260px;
    max-width: 260px;
  }
}

.plot-header-row {
  display: flex;
  align-items: center;
}
.plot-title {
  font-size: 17.50px;
  font-weight: 600;
  color: #222;
}
.create-btn-compact {
  width: 10px;
  height: 32px !important;
  padding: 6px !important;
  min-width: 20px;
  min-height: 32px;
  max-height: 32px;
  border-radius: 6px;
  margin-left: 150px;
  object-fit: contain;
}
.tabs-row {
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 0;
  padding-bottom: 0;
}
.dash-list-public {
  flex: 1;
  overflow-y: auto;
  padding: 0 0 8px 0;
}
.dash-list-items {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  margin: 2px 4px;
  font-size: 14.50px;
  transition: background 0.2s;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dash-list-items.active, .dash-list-items:hover {
  background: #f0f0f0;
  font-weight: bold;
  color: inherit;
  border: none;
}
.dash-name {
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
.globe-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  flex-shrink: 0;
}

/* Chart actions styles */
.chart-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 1;
  transition: opacity 0.2s;
}

</style> 